import {Component, OnInit} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from '@services/language.service';
import { NewlanguageComponent } from './newlanguage/newlanguage.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-blank',
    templateUrl: './blank.component.html',
    styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit {
    languages:any[]=[];
  
    constructor(private modal:NgbModal,private languageService:LanguageService) {
      
        
    }

    ngOnInit(): void {
            this.getLangs();
    }


    getLangs(){
        this.languageService.all().subscribe(res=>{
            this.languages=res;
           
        })
    }


    openSaveModal(){
        const modalref=  this.modal.open(NewlanguageComponent, { size: 'lg' });
        
        modalref.result.then((result)=>{
         this.getLangs();
        });
    
        }


    
    detail(data:any){
        const modalref=  this.modal.open(NewlanguageComponent, { size: 'lg' });
            modalref.componentInstance.data=data;
        modalref.result.then((result)=>{
         this.getLangs();
        });

    }
    delete(data:any){

        Swal.fire({
            title: 'Dikkat',
            text: "Bu avatar silinecek! Onaylıyor musunuz?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet',
            cancelButtonText: 'İptal',
          }).then((result) => {

           
            if (result.isConfirmed) {

                this.languageService.delete(data).subscribe(res=>{
                    this.getLangs();
                    Swal.fire(
                        'Başarılı!',
                        'avatar silindi',
                        'success'
                      )
                });
             
            }
          })

    }
}
